import styled from 'styled-components';

export const Overlay = styled.div`
	position: fixed;
	top: 0;
	left: 0;
	width: 100vw;
	height: 100vh;
	background-color: rgba(0, 0, 0, 0.5);
	display: flex;
	justify-content: center;
	align-items: center;
	z-index: 10001;
`;

export const ModalContainer = styled.div`
	background: white;
	padding: 20px;
	border-radius: 8px;
	box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
	width: 540px;
	min-height: 600px;
	max-width: 80%;
	box-sizing: border-box;
`;

export const Top = styled.div`
	display: flex;
	justify-content: space-between;
	margin-bottom: 10px;
`;

export const CloseButton = styled.button`
	position: relative;
	width: 22px;
	height: 22px;
	padding: 0;
	border: 0;
	background: transparent;
	cursor: pointer;

	&::before {
		content: '';
		position: absolute;
		z-index: 0;
		top: 50%;
		left: 50%;
		width: 40px;
		height: 40px;
		border-radius: 50%;
		background-color: transparent;
		transform: translate(-50%, -50%);
		transition: background-color 0.2s ease;
	}

	&:hover::before {
		background-color: ${({ theme }) => theme.colors.lightGray};
	}

	.close {
		position: relative;
		z-index: 1;
		display: block;
		width: 22px;
		height: 22px;
		transform: rotate(45deg);
	}
`;

export const Title = styled.p`
	color: ${({ theme }) => theme.colors.darkText};
	font: ${({ theme }) => theme.fonts.footer.title};
`;
